module.exports = __webpack_public_path__ + "static/media/landmark_bound.78e171bf.png";